const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
	
    if (window.location.hostname.includes('1xbet')) {
      pageType = '1xbet'
    } else {
      pageType = 'Home'
    }
    
    utils.loadStyle('.ocm-sticky.bottom {padding:0px !important}')

    resolve(pageType)
  });
};
module.exports = pageSense;